import { SvgIconDefinition } from '@am/icons-common-types';
import { aciLaundry } from '@am/common-svg-icons';

export const aciLaundryFacilities: SvgIconDefinition = {
  ...aciLaundry,
  iconName: 'laundry-facilities',
};
